<template>
  <div>
    <div class="pt-2 pl-2">
      <div class="input-group" v-for="staff in sortedStaffs" :key="staff.id">
        <p class="pr-2">
          <a href="#" @click.prevent="remove(staff.id)" :class="{disabled:disabled}">Ｘ</a>
        </p>
        <p>
          {{staff.display_name}}
        </p>
      </div>
      <div v-if="inputs.staffs.length === 0">
        <p>スタッフを選択してください。</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch, computed, defineProps, defineEmits } from 'vue'
import _ from 'lodash'
import utils from '@/libs/Utils'

const props = defineProps({
  modelValue: Array,
  disabled: Boolean
})

const emit = defineEmits(['update:modelValue'])

// Reactive state
const inputs = reactive({
  staffs: []
})

const sortedStaffs = computed(() => utils.sortStaffsByKana(inputs.staffs || []))

// Watch for modelValue changes
watch(() => props.modelValue, (newVal) => {
  inputs.staffs = newVal ? [...newVal] : []
}, { immediate: true })

// Methods
const remove = (staffId) => {
  if (props.disabled) return
  const index = _.findIndex(inputs.staffs, staff => {
    return staff.id === staffId
  })
  if (index < 0) return

  const updatedStaffs = [...inputs.staffs]
  updatedStaffs.splice(index, 1)

  emit('update:modelValue', utils.sortStaffsByKana(updatedStaffs))
}
</script>

<style lang="scss" scoped>
.disabled {
  cursor: not-allowed;
  color: gray
}
</style>
